import React from 'react';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import MexicoFlag from '../../Images/MexicoFlag.svg';
import USAFlag from '../../Images/USAFlag.svg';
import SpainFlag from '../../Images/SpainFlag.svg'; 
import { setLanguage } from '../../Redux/languageSlice';

function LanguageBtn(props) {
  const dispatch = useDispatch();
  const { i18n } = useTranslation();

  const handleLanguageChange = (language) => {
    dispatch(setLanguage(language));
    i18n.changeLanguage(language);
  };

  return (
    <div className='flag-group'>
      <button className='flag-btn' onClick={() => handleLanguageChange('en')}>
        <img src={USAFlag} alt="Inglés" />
      </button>
      <button className='flag-btn' onClick={() => handleLanguageChange('es')}>
        <img src={SpainFlag} alt="Español" />
      </button>
      {/* <button className='flag-btn' onClick={() => handleLanguageChange('es')}>
        <img src={MexicoFlag} alt="Español (México)" />
      </button> */}
    </div>
  );
}

export default LanguageBtn;